/** 
 * Rol types
 */
export enum ROLES {
    ADMINISTRADOR = "ROL_ADMINISTRADOR",
    DIRECTOR = "ROL_DIRECTOR",
    SUBDIRECTOR = "ROL_SUBDIRECTOR",
    JEFE_DE_AREA = "ROL_JEFE_DE_AREA",
    AUDITOR = "ROL_AUDITOR",
    AUDITADO = "ROL_AUDITADO",
    VALIDADOR = "ROL_VALIDADOR",
    ASISTENTE = "ROL_ASISTENTE",
    CUESTIONARIO = "ROL_CUESTIONARIOS",
    ADMINISTRACION_GLOBAL = "ROL_ADMINISTRACION_GLOBAL",
    ADMINISTRACION_DIVISAS = "ROL_ADMINISTRACION_DIVISAS",
    ADMINISTRACION_ESTRUCTURAS = "ROL_ADMINISTRACION_ESTRUCTURAS",
    ADMINISTRACION_RHUMANOS = "ROL_ADMINISTRACION_RHUMANOS",
    ADMINISTRACION_DPTOS = "ROL_ADMINISTRACION_DPTOS",
    ADMINISTRACION_USUARIOS = "ROL_ADMINISTRACION_USUARIOS",
    ADMINISTRACION_AEXTERNAS = "ROL_ADMINISTRACION_AEXTERNAS",
    ADMINISTRACION_CUESTIONARIOS = "ROL_ADMINISTRACION_CUESTIONARIOS",
    ADMINISTRACION_NOTICIAS = "ROL_ADMINISTRACION_NOTICIAS",
    ADMINISTRACION_PROCESOS = "ROL_ADMINISTRACION_PROCESOS",
    ADMINISTRACION_PROGRAMA_TRABAJOS = "ROL_ADMINISTRACION_PROGRAMA_TRABAJOS",
    FUNC_PAI = "ROL_FUNC_PAI",
    FUNC_TRABAJOS = "ROL_FUNC_TRABAJOS",
    FUNC_RRHH = "ROL_FUNC_RRHH",
    FUNC_PREV_PLANTILLA = "ROL_FUNC_PREV_PLANTILLA",
    FUNC_PRESUPUESTOS = "ROL_FUNC_PRESUPUESTOS",
    FUNC_GESTION = "ROL_FUNC_GESTION",
    ADMINISTRACION_MANTENIMIENTO = "ROL_ADMINISTRACION_MANTENIMIENTO",
    MAIA = "ROL_MAIA"
}

/** 
 * Types of job states
 */
export enum JOB_STATES {
    PLANIFICACION = "EN_PLANIFICACION",
    CURSO = "EN_CURSO",
    BORRADOR = "INFORME_BORRADOR",
    DEFINITIVO = "INFORME_DEFINITIVO",
    CANCELADO = "CANCELADO"
}

/** 
 * Types of close periods
 */
// export enum CLOSE_PERIOD_TYPES {
//     CIERRE_PRINCIPAL = "CIERRE_PRINCIPAL",
//     PLANES_DE_AUDITORIA = "PLANES_DE_AUDITORIA",
//     TIEMPOS = "TIEMPOS",
//     GASTOS = "GASTOS",
//     PREVISIONES_DE_PLANTILLA = "PREVISIONES_DE_PLANTILLA"
// }

export enum CLOSE_PERIOD_TYPES {
    CIERRE_PRINCIPAL = 1,
    PLANES_DE_AUDITORIA = 2,
    TIEMPOS = 3,
    GASTOS = 4,
    PREVISIONES_DE_PLANTILLA = 5,
    TRABAJOS = 6
}

export enum ACTION_PLAN_STATES {
  EN_CURSO = 1,
  PENDIENTE = 2,
  RECIBIDO = 3,
  CONFORME = 4,
  INCOMPLETO = 5
}

export enum RECOMMENDATION_STATUS {
  PENDIENTE = 1,
  IMPLANTADA = 3,
  NO_CONSIDERADA = 4
}

export const MIN_PARAGRAPHS_OP: number = 2;
export const MAX_PARAGRAPHS_OP: number = 10;
export const MIN_PARAGRAPH_LENGTH_OP: number = 80;

